<div edsRow>
  <div edsCol>
    <ng-container *ngIf="page">
      <ng-container *ngIf="brConfig?.fundId; else previewBlock">
        <ng-container *ngIf="tradingInformationInfo?.exchanges.length > 0">
          <eds-panel
            class="list-details"
            [hasBorders]="true"
            [hasPadding]="true"
            edsSpacing="md"
          >
            <eds-title
              class="text-primary"
              [isLight]="true"
              size="h6"
              edsSpacing="lg"
              >{{
                "products.trading-information-header"
                  | translate: brConfig.fundId
              }}</eds-title
            >
            <!-- grid -->
            <div edsRow *ngIf="(isHandheld$ | async) === false">
              <div edsCol>
                <ag-grid-angular
                  #tradingGrid
                  style="width: 100%; height: 100%"
                  class="ag-theme-frk"
                  [rowData]="sortedTableRows"
                  [columnDefs]="columnDefs"
                  [defaultColDef]="defaultColDef"
                  [frameworkComponents]="frameworkComponents"
                  [context]="gridContext"
                  domLayout="autoHeight"
                  (sortChanged)="onSortChanged()"
                  headerHeight="100"
                  [suppressCellSelection]="false"
                  [ensureDomOrder]="true"
                  [enableCellTextSelection]="true"
                  (gridReady)="onGridReady()"
                >
                </ag-grid-angular>
              </div>
            </div>
            <!-- mobile view -->
            <div *ngIf="isHandheld$ | async">
              <eds-panel
                edsSpacing="sm"
                [hasBorders]="true"
                [hasBorderRadius]="false"
                [hasPadding]="true"
              >
                <eds-dropdown
                  edsSpacing="md"
                  [items]="exchangeItems"
                  [label]="'products.list-all-exchanges' | translate"
                  (dropdownChange)="filterExchange($event)"
                ></eds-dropdown>
              </eds-panel>

              <div class="cards-mobile">
                <eds-panel
                  edsSpacing="sm"
                  [hasBorders]="true"
                  [hasBorderRadius]="false"
                  [hasPadding]="true"
                  *ngFor="let exchanges of sortedTableRows"
                >
                  <div *ngFor="let colDef of columnDefs[0].children">
                    <eds-info-item
                      *ngIf="!colDef.hide"
                      [info]="getInfoItem(exchanges, colDef)"
                      edsSpacing="sm"
                    ></eds-info-item>
                  </div>
                </eds-panel>
              </div>
            </div>
            <!-- mobile view -->
            <!-- grid -->
          </eds-panel>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-template #previewBlock>
      <h5>Trading Information Component</h5>
    </ng-template>
  </div>
</div>
